import { SapAccount, SapPurchasableItem } from '@allurion/domain';
import { ONE_MINUTE_IN_MS } from '@allurion/utils';
import useSWR from 'swr';

import { buildUrl, InsightsApi } from 'src/api/Api';

const PATHNAME = (clinicId: string) => `/clinics/${clinicId}/order-setup`;

export function useClinicOrderSetup(clinicId?: string) {
  const url = clinicId && buildUrl(PATHNAME(clinicId.toString()));
  const { data, error, isValidating } = useSWR(
    url,
    (_url: string) =>
      InsightsApi.get<{ account: SapAccount; purchasableItems?: SapPurchasableItem[] }>(_url),
    {
      revalidateOnFocus: false,
      dedupingInterval: ONE_MINUTE_IN_MS,
    }
  );

  return {
    isLoading: isValidating,
    accountName: data?.account.alternatePaymentName ?? data?.account?.name,
    billingAddresses: data?.account?.billingAddresses ?? [],
    shippingAddresses: data?.account?.shippingAddresses ?? [],
    purchasableItems: data?.purchasableItems ?? [],
    error,
  };
}
